import { Shape } from './ShapeInterface';
import Konva from "konva";
import { DrawFence } from './DrawFence';
import { Global } from "../utilities/global";


export class FenceTriangle implements Shape {
	x: number;
	y: number;
	width: number;
	toolTip: string;
	height: number;

	drawShape(start: any, end: any, name: string, point?: any): any {
		return this.getTriangle(start, end, name, null)
	}
	getTriangle(start: any, end: any, name: string, points: any) {
		const p: number[] = points;
		DrawFence.FenceCount++;
		return new Konva.Line({
			points: start != null ? [(start.x + end.x) / 2, start.y, end.x, end.y, start.x, end.y] : p,
			stroke: '#ffffff',
			strokeWidth: 0,
			fill: DrawFence.fillColor,
			draggable: true,
			closed: true,
			name: Global.nonUsableArea,
			id: name + DrawFence.FenceCount
		});
	}
}